import { useEffect, useRef } from 'react';

/**
 * When global intake status moves off `push_failed` (e.g. admin reset to
 * pending_review), clear in-memory EMR attempt payloads. Otherwise React state
 * from the failed attempt keeps `pushOrScheduleFailed` true and the Push to
 * EMR action stays blocked even though the server no longer reports push_failed.
 */
export function useClearStaleEmrAttemptWhenPushFailedReleased(
  intakeId: string | undefined,
  intakeStatus: string | null | undefined,
  clearAttemptResults: () => void
): void {
  const prevStatusRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    prevStatusRef.current = undefined;
  }, [intakeId]);

  useEffect(() => {
    const prev = prevStatusRef.current;
    const curr = intakeStatus ?? undefined;
    if (prev === 'push_failed' && curr !== 'push_failed') {
      clearAttemptResults();
    }
    prevStatusRef.current = curr;
  }, [intakeStatus, clearAttemptResults]);
}
